import { IconAttention, InfoAlert } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchResultsListStyled } from './styles/GlobalSearchResultsListStyled'
import { GlobalSearchTruncatedNoticeWrapperStyled } from './styles/GlobalSearchTruncatedNoticeWrapperStyled'
import { GlobalSearchListbox } from '../../../../components/GlobalSearchListbox'
import { type GlobalSearchResultItem } from '../../../../value-objects/GlobalSearchResultItem'
import { GlobalSearchListItem } from '../GlobalSearchListItem'

interface IGlobalSearchResultsListProps {
  listboxId: string
  items: GlobalSearchResultItem[]
  showTruncatedNotice: boolean
  highlightedIndex: Nullable<number>
  onResultItemClick: (item: GlobalSearchResultItem) => void
}

export const GlobalSearchResultsList = ({
  listboxId,
  items,
  showTruncatedNotice,
  highlightedIndex,
  onResultItemClick,
}: IGlobalSearchResultsListProps) => {
  const intl = useProcurifyIntl()

  return (
    <GlobalSearchResultsListStyled>
      <GlobalSearchListbox
        id={listboxId}
        ariaLabel={intl.formatMessage(messages.listboxAriaLabel)}
        highlightedIndex={highlightedIndex}
      >
        {items.map((item, index) => (
          <GlobalSearchListItem
            key={item.uuid}
            uuid={item.uuid}
            type={item.type}
            id={item.id}
            label={item.label}
            metadata={item.metadata}
            isHighlighted={index === highlightedIndex}
            onClick={() => onResultItemClick(item)}
          />
        ))}
      </GlobalSearchListbox>
      {showTruncatedNotice && (
        <GlobalSearchTruncatedNoticeWrapperStyled>
          <InfoAlert icon={<IconAttention />}>
            {intl.formatMessage(messages.truncatedNotice)}
          </InfoAlert>
        </GlobalSearchTruncatedNoticeWrapperStyled>
      )}
    </GlobalSearchResultsListStyled>
  )
}
